<template>
  <div>
    <component
      :is="Form"
      :role-type="roleType"
      :loading-next="loadingNext"
      :is-alternative-service-edit="isAlternativeServiceEdit"
      :subject-name="subjectName"
      :statement-type="statementType"
      @prev="$emit(StepDirection.PREV, $event)"
      @next="$emit(StepDirection.NEXT, $event)"
    ></component>
  </div>
</template>

<script>
import { ServicesModule } from '@/store/modules/services';
import { SubjectFillType, SubjectName } from '@/constants';
import { StatementType, StepDirection } from '@/types/services';
import MrpaSubjectForm from '@/components/services/common/MrpaSubjectForm';

import EgrnTrustee from '@/components/services/EgrnConfirm/Applicant/MrpaEnable/Trustee/MrpaEnableTrustee';
import EgrnMrpa from '@/components/services/EgrnConfirm/Applicant/MrpaEnable/Mrpa/Mrpa';
import EgrnAssignee from '@/components/services/EgrnConfirm/Applicant/MrpaEnable/Assignee/MrpaEnableAssignee';

import NoticeRecoveryManual from '@/components/services/NoticeRecovery/Applicant/Manual';
import NoticeRecoveryMachine from '@/components/services/NoticeRecovery/Applicant/Machine';

import SecuringEvidenceManual from '@/components/services/SecuringEvidence/Applicant/Manual';
import StorageAcceptManual from '@/components/services/StorageAccept/Applicant/Manual';
import StorageIssueManual from '@/components/services/StorageIssue/Applicant/Manual';
import CorrectTranslationManual from '@/components/services/CorrectTranslation/Applicant/Manual';
import TransferElDocsManual from '@/components/services/TransferElDocs/Applicant/Manual';
import RuzdiManual from '@/components/services/RUZDI/Applicant/Manual';
import DocumentConversionManual from '@/components/services/DocumentConversion/Applicant/Manual';
import AcceptanceDepositManual from '@/components/services/AcceptanceDeposit/Debtor/Manual';

const mapManualForm = {
  [StatementType.EGRN_CONFIRM]: EgrnTrustee,
  [StatementType.NOTICE_RECOVERY]: NoticeRecoveryManual,
  [StatementType.SECURING_EVIDENCE]: SecuringEvidenceManual,
  [StatementType.STORAGE_ACCEPT]: StorageAcceptManual,
  [StatementType.STORAGE_ISSUE]: StorageIssueManual,
  [StatementType.CORRECT_TRANSLATION]: CorrectTranslationManual,
  [StatementType.TRANSFER_EL_DOCS]: TransferElDocsManual,
  [StatementType.RUZDI]: RuzdiManual,
  [StatementType.DOCUMENT_CONVERSION]: DocumentConversionManual,
  [StatementType.ACCEPTANCE_DEPOSIT]: AcceptanceDepositManual,
};

const mapMachineForm = {
  [StatementType.EGRN_CONFIRM]: EgrnMrpa,
  [StatementType.NOTICE_RECOVERY]: NoticeRecoveryMachine,
  [StatementType.SECURING_EVIDENCE]: MrpaSubjectForm,
  [StatementType.STORAGE_ACCEPT]: MrpaSubjectForm,
  [StatementType.STORAGE_ISSUE]: MrpaSubjectForm,
  [StatementType.CORRECT_TRANSLATION]: MrpaSubjectForm,
  [StatementType.TRANSFER_EL_DOCS]: MrpaSubjectForm,
  [StatementType.RUZDI]: MrpaSubjectForm,
  [StatementType.DOCUMENT_CONVERSION]: MrpaSubjectForm,
  [StatementType.ACCEPTANCE_DEPOSIT]: MrpaSubjectForm,
};

const mapAssigneeForm = {
  [StatementType.EGRN_CONFIRM]: EgrnAssignee,
};

export default {
  name: 'SubjectFillType',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
    roleType: {
      type: String,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
    isAlternativeServiceEdit: {
      type: Boolean,
      required: true,
    },
    subjectName: {
      type: String,
      default: SubjectName.APPLICANT,
    },
  },
  data() {
    return {
      StepDirection,
    };
  },
  computed: {
    Form() {
      const fillType =
        ServicesModule.statement.subjects[this.subjectName]?.uiContext
          ?.fillType;

      if (fillType === SubjectFillType.MACHINE) {
        return mapMachineForm[this.statementType];
      }

      if (fillType === SubjectFillType.ASSIGNEE) {
        return mapAssigneeForm[this.statementType];
      }

      return mapManualForm[this.statementType];
    },
  },
};
</script>
